import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { GraphicsComponent } from '../graphics/graphics.component';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { ResizePipe } from '@teamfoster/sdk/image';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, GraphicsComponent, FromDictionaryPipe, ResizePipe],
})
export class HeaderComponent {
  readonly title = input<string>();
  readonly text = input<string>();
  readonly subTitle = input<string>();
  readonly imgUrl = input<string>();
  readonly imgAnchor = input<
    | 'topleft'
    | 'topcenter'
    | 'topright'
    | 'middleleft'
    | 'middlecenter'
    | 'middleright'
    | 'bottomleft'
    | 'bottomcenter'
    | 'bottomright'
    | undefined
  >();
  readonly cssClass = input<string>();
  readonly dictionaryPrefix = input<string>();
  readonly link = input<RouterLink | string>();

  readonly graphic = input<'hexagon' | 'rond' | 'cel' | 'stippen' | null>();
}
